import type { EmployeeMedicationDto } from "@/generated/model/employeeMedicationDto";
import { useProfileSectionEditing } from "@/hooks/use-profile-section-form";
import { textOrNotRecorded, yesNo } from "@/lib/people";

import { EditMedicationForm } from "../forms/EditMedicationForm";
import { ProfileSectionCard } from "../ProfileSectionCard";
import { ProfileSectionEditButton } from "../ProfileSectionEditButton";
import { ConfidentialNote } from "../SensitiveSectionNotes";

interface MedicationSectionProps {
  nurseryId: string;
  userId: string;
  medication: EmployeeMedicationDto;
  canEdit: boolean;
}

export function MedicationSection({
  nurseryId,
  userId,
  medication,
  canEdit,
}: MedicationSectionProps) {
  const { editing, editButtonRef, startEditing, stopEditing } =
    useProfileSectionEditing();

  return (
    <ProfileSectionCard
      title="Medication details"
      testId="profile-section-medication"
      action={
        canEdit &&
        !editing && (
          <ProfileSectionEditButton
            ref={editButtonRef}
            section="medication details"
            onClick={startEditing}
          />
        )
      }
      editForm={
        canEdit &&
        editing && (
          <EditMedicationForm
            nurseryId={nurseryId}
            userId={userId}
            medication={medication}
            onDone={stopEditing}
          />
        )
      }
      fields={[
        {
          label: "Takes regular medication",
          value: yesNo(medication.takesRegularMedication),
        },
        {
          label: "Regular medication details",
          value: textOrNotRecorded(medication.regularMedicationDetails),
        },
        {
          label: "Emergency medication details",
          value: textOrNotRecorded(medication.emergencyMedicationDetails),
        },
      ]}
    >
      <ConfidentialNote text="Medication details are confidential. Only you and Deputy Manager and above can see them." />
    </ProfileSectionCard>
  );
}
